<template>
    <v-container
      class="py-0"
      fluid>
        <v-row
            align="center"
            justify="center"
            class="dashboard-links"
        >
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="4"
            >
                <v-card
                    light
                    to="/properties"
                    outlined
                    color="#0d80d7"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="white--text"
                        >
                            mdi-city
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Properties</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="4"
            >
                <v-card
                    light
                    to="/calendar"
                    outlined
                    color="#0d80d7"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="white--text"
                        >
                            mdi-calendar
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Calendar</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="6"
                lg="4"
            >
                <v-card
                    light
                    to="/tasks"
                    outlined
                    color="#0d80d7"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="white--text"
                        >
                            mdi-check-decagram
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Task Manager</span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import authmixin from '../mixin/auth.js'
    import { mapActions } from 'vuex' 
    export default {
        mixins: [authmixin],
        data: () => ({

        }),
        computed: {
        },
        methods: {
            ...mapActions({
                getData: 'data/getData'
            })
        },
        mounted() {
            this.getData()
        }
    }
</script>
<style lang="sass">
.v-content
    background: #494949

.dashboard-links
    padding: 4px
    
    .col-12
        padding: 4px

        .v-card 
            display: flex
            flex-wrap: wrap
            align-content: center
            justify-content: center
            min-height: calc((100vh - 88px) / 3)

.v-application 
    .headline
        font-family: 'Pyxel'!important
        font-size: 1.5em!important

@media only screen and (min-width: 768px)
    .dashboard-links
        .col-12
            .v-card 
                min-height: calc((100vh - 80px))
</style>